import React, { FC } from 'react';
import { Box, Stack } from '@mui/material';
import {
  ImgBox,
  Typography700,
} from 'views/rebranded-module/common/components';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import StyledButtonBase from 'views/rebranded-module/common/components/UI/BlogCardV2/BlogCardV2.styles';
import { BlogCardProps } from 'views/rebranded-module/common/components/UI/BlogCardV2/BlogCardV2.interface';
import stripTags from 'views/common/utils/stripTags';
import Typography500 from 'views/common/components/UI/Typography500';
import dayjs from 'dayjs';
import { DATE_FORMAT_READABLE } from 'views/rebranded-module/common/utils/dateFormate';
import { RiCalendar2Fill } from 'react-icons/ri';

const BlogCardV2: FC<BlogCardProps> = (props) => {
  const { image, title, date, path, description, stretched } = props;
  const formattePostDate = (date: string) =>
    dayjs(date).format(DATE_FORMAT_READABLE);
  return (
    <StyledButtonBase
      className={`${stretched ? 'BCStrachedCard' : ''}`}
      component={NavigatorLink}
      href={path}>
      <Stack className="BCContainer" alignItems="start">
        <Box className="BCImgContainer">
          <ImgBox
            image={{
              src: image || 'imgs/Rebranding/logos/default.jpg',
              alt: title,
            }}
            width="100%"
            height="100%"
            objectFit="cover"
            unoptimized
          />
        </Box>
        <Box className="BCDetailsContainer">
          <Typography700 className="BCTitle" variant="h5" component="p" mb={1.5}>
            {title}
          </Typography700>

          {description && (
            <Typography500
              variant="body1"
              component="p"
              className="BCMaxText"
              color="text.secondary"
              dangerouslySetInnerHTML={{
                __html: stripTags(description),
              }}
            />
          )}

          {date && (
            <Box className="BCDateContainer">
              <Typography700
                variant="body2"
                component="p"
                className="BCDateText">
                <RiCalendar2Fill className="BCDateIcon" />
                {formattePostDate(date)}
              </Typography700>
            </Box>
          )}
        </Box>
      </Stack>
    </StyledButtonBase>
  );
};

export { BlogCardV2 };
